/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* istanbul ignore file */
import * as Survey from "survey-react";
import { PersonRequest } from "@plinknz/tah-website-elements";

import { APPLIED_STATUS, GrantPayload } from "../../config/forms";
import { createSVGNew } from "../svg/svg";
import { PageConfig } from "../../components/content-blocks/forms/customer-form-types";
import { collapseSurrogate } from "../../service/forms/config-generics/personal-details";
import { EmailPayload } from "../../config/forms/contact/payload";

export function transformBenefitFormData(
  survey: Survey.ReactSurveyModel,
  member: PersonRequest,
  config: { pages: PageConfig[] },
  type: string,
  email?: string,
  emailSubject?: string,
  targetType?: string
): GrantPayload {
  const now = new Date().getTime();
  const tenant = process.env.TAH_TENANT;
  const surveyData = survey.data;
  const data = collapseSurrogate(surveyData);
  const { svg: interaction, text } = createSVGNew({
    heading: `${type} Application`,
    data: {
      ...survey.data,
      member,
    },
    config,
  });

  const emailPayload: EmailPayload = {
    name: `${data.firstName} ${data.surname}`,
    email: data.email,
    message: text,
  };

  if (email) {
    emailPayload.emailTo = email;
  }

  if (emailSubject) {
    emailPayload.subject = emailSubject;
  }

  const payloadData: GrantPayload = {
    data: {
      interaction: {
        interaction,
        interactionDate: now,
      },
      email: emailPayload,
    },
    targetId: survey.data.id || member.id,
    recaptcha: null,
    tenant,
  };

  if (targetType === "none") {
    return payloadData;
  }

  if (
    targetType === "benefit" ||
    (targetType !== "event" &&
      (type.match("Grant") || type.match("Scholarship")))
  ) {
    payloadData.data.benefit = {
      benefitDescription: type,
      benefitStatus: APPLIED_STATUS,
      benefitDate: now,
    };
  } else {
    payloadData.data.event = {
      eventDescription: type,
      eventDate: now,
    };
  }

  return payloadData;
}
